<template>
  <div class="d-flex px-1 hidden-overflow-y" style="height: calc(100vh - 61px)">
    <v-col cols="6" class="pa-0 mt-1">
      <div class="border-card elevation-3 px-1 altura-card">
        <CaracteristicasProduto
          :produto="produto"
          :habilitar_edicao_parametros="habilitar_edicao_parametros"
          :ativar_filtro_revenda_direta="ativar_filtro_revenda_direta"
        />
      </div>
    </v-col>

    <v-col cols="6" class="pa-0 mt-1">
      <div class="border-card elevation-3 px-1 ml-1 altura-card">
        <TabelaDetalhesProdutos
          :produto="produto"
          :exibir_raio_x="exibir_raio_x"
          class="ml-1"
          :atualizar_detalhes_count="atualizar_detalhes_count"
          :habilitar_edicao_parametros="habilitar_edicao_parametros"
          :ativar_filtro_revenda_direta="ativar_filtro_revenda_direta"
          @update:lote-minimo="ev => $emit('update:lote-minimo', ev)"
          @update:tempo-ressuprimento="ev => $emit('update:tempo-ressuprimento', ev)"
          @update:influencia-projecao="ev => $emit('update:influencia-projecao', ev)"
          @update:cobertura-manual-estoque="ev => $emit('update:cobertura-manual-estoque', ev)"
          @update:previsao-gatilho="ev => $emit('update:previsao-gatilho', ev)"
          @update:similar="ev => $emit('update:similar', ev)"
          @update:heranca="ev => $emit('update:heranca', ev)"
          @update:desconsiderar-pedido-em-transito="ev => $emit('update:desconsiderar-pedido-em-transito', ev)"
          @update:tipo-projecao-aplicado="ev => $emit('update:tipo-projecao-aplicado', ev)"
          @consumos-desconsiderados="ev => $emit('consumos-desconsiderados', ev)"
        />

        <v-divider />

        <div class="mt-n1" :style="formatarAlturaGrafico">
          <GraficoMovimentacoesEstoqueProduto
            class="ml-n3 mt-n4"
            :produto="produtoGrafico"
            :atualizar_detalhes_count="Number(atualizar_detalhes_count)"
            :ativar_filtro_revenda_direta="ativar_filtro_revenda_direta"
          />
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import GraficoMovimentacoesEstoqueProduto from "./grafico/GraficoMovimentacoesEstoqueProduto";
import CaracteristicasProduto from "./TabelaCaracteristicasProduto";
import TabelaDetalhesProdutos from "./TabelaDetalhesProdutos.vue";
import {mapGetters} from "vuex";
import ProdutoAPI from "@/api/produto";

export default {
  name: "CardDetalhesProduto",
  components: {
    GraficoMovimentacoesEstoqueProduto,
    CaracteristicasProduto,
    TabelaDetalhesProdutos
  },
  props: {
    produto: {
      type: Object,
      required: true
    },
    exibir_raio_x: {
      type: Boolean,
      default: false
    },
    atualizar_detalhes_count: Number,
    habilitar_edicao_parametros: {
      type: Boolean,
      default: false
    },
    ativar_filtro_revenda_direta: Boolean,
  },
  data: () => ({
    detalhesProduto: {}
  }),
  mounted() {
    this.getDetalhesProdutos();
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    }),
    produtoGrafico() {
      return {
        grupo: this.produto.id_grupo,
        filial: this.produto.id_filial || 9999,
        produto: this.produto.id_produto,
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
        produto_eh_categoria: this.produto.produto_eh_categoria ? 'S' : 'N',
      }
    },
    tipoProjecaoVendas() {
      const v = this.detalhesProduto ? this.detalhesProduto.tipo_projecao_vendas : null;
      return v != null && v !== "" ? String(v) : "padrao_systock";
    },
    formatarAlturaGrafico() {
      let offset = 415;

      if (this.tipoProjecaoVendas !== 'padrao_systock') {
        offset = 453
      }

      return { height: `calc(100vh - ${offset}px)` }
    },
  },
  methods: {
    getDetalhesProdutos() {
      const { id_produto, id_grupo, id_filial } = this.produto;

      const params = {
        produto: id_produto,
        grupo: id_grupo,
        filial: id_filial || 9999,
        visaoDrp: this.produto.visaoDrp || undefined,
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
        produto_eh_categoria: this.produto.produto_eh_categoria ? 'S' : 'N',
        ativar_filtro_revenda_direta: this.ativar_filtro_revenda_direta ? 'S' : 'N',
        exibir_produtos_inativos: this.produto.exibir_produtos_inativos ? 'S' : 'N',
        incluir_produtos_fora_linha: this.produto.incluir_produtos_fora_linha ? 'S' : 'N',
      }

      if (params.visaoDrp && this.produto.tipoDrp) {
        params.tipoDrp = this.produto.tipoDrp;
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        ProdutoAPI.getDetalhesProduto(params)
        .then(response => {
          const {token, detalhes} = response.data;
          localStorage.token = token;
          this.detalhesProduto = detalhes;
        })
        .catch(() => (this.Helpers.logout()))
      );
    }
  }
}
</script>

<style scoped>
.border-card {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
}
.altura-card {
  height: calc(100vh - 68px);
}
</style>
